<div class="main">
    <a href="https://storyset.com/">
        <img src="assets/404/errorPage.svg" alt="">
    </a>
</div>